<template>
  <FieldValidator :name="name">
    <template v-slot="{ value, handleChange, isInvalid, errorMessage }">
      <AutoCompleteBox
        v-bind="fieldAttrs"
        :modelValue="value"
        @update:modelValue="handleChange"
        :class="{ 'p-invalid': isInvalid }"
        :label="label"
        ref="box"
      >
        <template v-if="isInvalid" #helperText>{{ errorMessage }}</template>
      </AutoCompleteBox>
    </template>
  </FieldValidator>
</template>

<script setup lang="ts">
import { ref, useAttrs } from 'vue';
import { AutoCompleteBox } from './../../../core/controls';
import { FieldValidator } from './../field-validator';

defineOptions({
  inheritAttrs: false,
});

defineProps({
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
  },
});

/** Root is FieldValidator (slot only); attrs must reach AutoCompleteBox (e.g. input-id for label association). */
const fieldAttrs = useAttrs();

const box = ref<InstanceType<typeof AutoCompleteBox>>();

defineExpose({ box });
</script>
